import { render, staticRenderFns } from "./ProjectTitle.vue?vue&type=template&id=02c7201d&scoped=true&"
import script from "./ProjectTitle.vue?vue&type=script&lang=js&"
export * from "./ProjectTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTitle.vue?vue&type=style&index=0&id=02c7201d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c7201d",
  null
  
)

export default component.exports